exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "fi-text-modal {\n  display: block;\n}\nfi-text-modal .info-dialog-content {\n  max-width: 600px;\n}\nfi-text-modal .info-dialog-content strong {\n  font-weight: 700;\n}", ""]);

// exports
